import React, {Component} from 'react'
import { money } from '../../utils/helpers'

class ProductTile extends Component {
  constructor(props) {
    super(props)
    this.state = {
      product: props.product,
      variant: props.variant,
      image: (props.variant.featured_image || props.variant.image) || (props.product.media.length > 0 ? props.product.media[0].preview_image : (props.product.featuredImage ? props.product.featuredImage : null)),
      variantPrice: props.variant.price && props.variant.price.amount ? parseFloat(props.variant.price.amount) * 100 : props.variant.price,
      variantCompPrice: props.variant.compareAtPrice && props.variant.compareAtPrice.amount ? parseFloat(props.variant.compareAtPrice.amount) * 100 : props.variant.compare_at_price,
      open: props.open,
      customAttributes: props.customAttributes || [],
    }
  }

  addToCart(e) {
    e.preventDefault()
    e.stopPropagation()
    const customAttributes = {}
    this.state.customAttributes.forEach(attr => customAttributes[attr.key] = attr.value)
    window.addLineItems(
      (res) => {
        e.target.innerHTML = `
          <svg class="icon icon-checkmark fill-current w-4 h-4 mr-2" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 9" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.35.643a.5.5 0 01.006.707l-6.77 6.886a.5.5 0 01-.719-.006L.638 4.845a.5.5 0 11.724-.69l2.872 3.011 6.41-6.517a.5.5 0 01.707-.006h-.001z" fill="currentColor"/>
          </svg>
          Added
          `
        
      },
      [
        {
          properties: customAttributes,
          id: parseInt(this.state.variant.id.toString().replace('gid://shopify/ProductVariant/', '')),
          quantity: 1
        }
      ],
      !window.location.href.includes("cart") ? true : this.state.open,
      window.location.href.includes("cart")
    )
  }

  badge() {
    if(this.state.variant.quantityAvailable <= 0)
      return 'Sold Out'
    else if((this.state.product.sash && this.state.product.sash.value == 'New') || this.state.product.tags.includes('New'))
      return 'New'
    else if(this.state.variant.compareAtPrice && parseFloat(this.state.variant.compareAtPrice.amount) > parseFloat(this.state.variant.price.amount))
      return 'On Sale'
    else if((this.state.product.sash && this.state.product.sash.value == 'Best Seller') || this.state.product.tags.includes('Best Seller'))
      return 'Best Seller'
    else
      return null
  }

  render() {
    return (
      <a className='relative block bg-puffco-grey-5 w-[12.5rem] h-[15.625rem] overflow-hidden' href={`/products/${this.state.product.handle}?variant=${this.state.variant.id}`}>
        {
          this.state.image ? <img className='absolute top-1/2 left-1/2 w-[80%] h-[60%] transform -translate-x-1/2 -translate-y-1/2 object-contain object-center' src={this.state.image.src || this.state.image.url} alt={ this.state.product.title } /> : ''
        }
        {
          this.badge() ? <span className='w-[3.125rem] h-5 inline-flex items-center justify-center bg-black text-white text-[0.5rem] absolute top-0 right-0'>{ this.badge() }</span> : ''
        }
        <div className='absolute top-5 left-4 right-4'>
          <p className='text-[0.75rem] leading-6 text-black font-semibold'>{ this.state.product.title }{ !this.state.variant.title || this.state.variant.title == 'Default Title' ? '' : ` - ${this.state.variant.title}` }</p>
          <p className='text-[0.75rem] leading-6 text-black'>${money(this.state.variantPrice)}</p>
        </div>
        <button className='secondary-dark-small absolute left-4 bottom-4 right-4 !px-4 hover:no-underline' onClick={(e) => {this.addToCart(e)}}>Add To Cart</button>
      </a>
    )
  }
}

export default ProductTile